
import {
    Box,
    IconButton,
    Fab,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "src/stateManagement/redux";
import { config } from "src/stateManagement/redux/configVar";
import {
    createLocationTag,
    deleteLocationTag,
} from "src/stateManagement/redux/slices/location/asyncReducers";
import Swal from "sweetalert2";
import FlagIcon from '@mui/icons-material/Flag';
import WarningIcon from '@mui/icons-material/Warning';
import { FlagTable } from "./components/flagTable";
import AddIcon from "@mui/icons-material/Add";
import { WarningTable } from "./components/warningTable";
import { ModalComponent } from "./components/modal";
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import { getTagList } from "src/shared/util/requestDataServer";

interface Props {
    open: boolean;
    handleModalTags: any;
}

interface Variable {
    id: string;
    name: string;
}

const serverUrl = config.serverUrl;




const internalTabs = [
    { "name": "Flags", "value": "Flags", icon: <FlagIcon />, svg: undefined },
    { "name": "warnings", "value": "warnings", icon: <WarningIcon />, svg: undefined },
]

export const Tags = () => {
    const dispatch = useDispatch();
    const { locationTags, locationSetPoints, locationId } = useSelector(
        (state) => state.location
    );

    const [tags, settags] = useState<Variable[]>([]);

    const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0].value)

    const [showModalTags, setShowModalTags] = useState(false);

    const [activeEditTag, setActiveEditTag] = useState<any>(undefined)


    useEffect(() => {
        getTagList().then((data) => {
            settags(data);
        });
    }, []);


    const handleDeleteTag = (id: string) => {
        const data = {
            id
        };

        Swal.fire({
            title: "Estas seguro?",
            text: "Quieres eliminar este Tag?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "SI, eliminar!",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteLocationTag(data, locationId));
                Swal.fire({
                    title: "Eliminado!",
                    icon: "success",
                });
            }
        });
    };

    const handleEditTag = (locTagId: string) => {
        const activeLocTag = locationTags.find((tag) => tag.id === locTagId);
        setActiveEditTag(activeLocTag);
        setShowModalTags(true);
    }


    const onClickChangeSummaryView = (tabId: string) => {
        setactiveSummaryView(tabId)
    }

    const handleModalTags = () => {
        setShowModalTags(!showModalTags);
        setActiveEditTag(undefined);
    };

    const onClickGetAlertsFromWell = async () => { }

    return (
        <Grid>
            <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                <Grid sx={{ display: "flex", justifyContent: "flex-start", gap: 1 }}>
                    {
                        internalTabs.map((item, index) => {
                            return (
                                <IconButton
                                    onClick={() => onClickChangeSummaryView(item.value)}
                                    key={index}
                                    sx={{
                                        backgroundColor: activeSummaryView === item.value ? "#1976d2" : "#f0f0f0",
                                        color: activeSummaryView === item.value ? "#fff" : "#000",
                                        "&:hover": {
                                            backgroundColor: activeSummaryView === item.value ? "#42a5f5" : "#f0f0f0",
                                        },
                                    }}
                                >
                                    {item.icon ? item.icon : <img src={item?.svg} alt="icon" width={25} height={25} />}
                                </IconButton>
                            )
                        })
                    }
                </Grid>
                {/* Buttons Right */}
                <Grid sx={{ display: "flex", justifyContent: "flex-end" }}>
                    {/* <IconButton
                        onClick={onClickGetAlertsFromWell}
                        sx={{
                            backgroundColor: "#25D366",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#128C7E",
                            },
                        }}
                    >
                        <AutoGraphIcon />
                    </IconButton> */}
                </Grid>
            </Grid>
            {activeSummaryView === "Flags" && (
                <FlagTable
                    handleEditTag={handleEditTag}
                    handleDeleteTag={handleDeleteTag}
                />
            )}

            {activeSummaryView === "warnings" && (
                <WarningTable
                    handleEditTag={handleEditTag}
                    handleDeleteTag={handleDeleteTag}
                />
            )}

            <ModalComponent
                showModalTags={showModalTags}
                handleModalTags={handleModalTags}
                tags={tags}
                activeEditTag={activeEditTag}
            />


            <Grid
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 4,
                }}
            >
                <Fab
                    size="small"
                    color="primary"
                    aria-label="add"
                    onClick={handleModalTags}
                >
                    <AddIcon />
                </Fab>
            </Grid>
        </Grid>
    );
};
